/**
 * App constants
 */
export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

const EVENT_STATUS = {
  IN_PROGRESS: 'in_progress',
  HUNT_POST_EVENT: 'hunt_post_event', // Hunt post event
  PREREGISTRATION: 'preregistration',
  DISCOVERING: 'discovering',
  OPEN: 'open', // Access for candidate and recruiter,
  CLOSED: 'closed',
};

const EVENT_FORMAT = {
  VIRTUAL: 'virtual',
  PHYSICAL: 'physical',
  HYBRID: 'hybrid',
};

const EVENT_TYPE = {
  jpo: 'jpo',
  seekube: 'seekube',
  school: 'school',
  company: 'company',
};

const DASHBOARD_MODE = {
  STATIC: 'static',
  DYNAMIC: 'dynamic',
};

const KEY_CODE = {
  ENTER: 13,
};

const INTERVIEW_CONTEXTS = ['unconfirmed', 'confirmed', 'interview', 'refused'];

const CONTEXT_URLS = {
  confirmed: 'interview/confirmed',
  unconfirmed: 'interview/unconfirmed',
  interview: 'interview/interview',
  refused: 'interview/refused',
  score0: 'refuse',
  score1: 'save',
  score2: 'top',
};

/**
 * Disable service for specific companies
 */
const DISABLE_SERVICE_FOR_COMPANIES = {
  INTERCOM: ['orano', 'orano-group'],
};

const ENABLE_SERVICE_FOR_TEST = {
  SYNC_CALENDAR: ['subscription', 'welcomePack', 'oneShot'],
  SYNC_OUTLOOK_USERS: [],
};

const WORDS_IN_SLUG_FOR_WOMEN_EVENT = ['femme', 'feminin'];

const PARTICIPANT_ROLE = {
  candidate: 'candidate',
  recruiter: 'recruiter',
};

const USERS_EVENT_ROLES = {
  public: 'public',
  guest: 'guest',
  recruiter: 'recruiter',
  participant: 'participant',
  owner: 'owner',
  admin: 'admin',
};

const USERS_TYPE = {
  candidate: 'candidate',
  recruiter: 'recruiter',
  owner: 'owner',
  admin: 'admin',
};

const USER_ROLE = {
  PARTICIPANT: 'participant',
  RECRUITER: 'recruiter',
  EVENT_OWNER: 'eventOwner',
  SEEKUBE: 'seekube',
  MANAGER: 'manager',
};

const LINKS = {
  intercom_help_candidate: {
    fr: 'https://intercom.help/seekube/fr/collections/2627090-je-suis-candidat',
    en: 'https://intercom.help/seekube/en/collections/2627090-i-am-a-candidate',
  },
  intercom_help_recruiter: {
    fr: 'https://intercom.help/seekube/fr/collections/2627091-je-suis-recruteur',
    en: 'https://intercom.help/seekube/en/collections/2627091-i-am-recruiter',
  },
  publish_offer: {
    fr: 'https://help.seekube.com/fr/articles/4689036-publier-une-offre',
    en: 'https://help.seekube.com/en/articles/4689036-posting-a-job',
  },
};

const ANALYTICS_RECRUITER = {
  CLICKED_VIEW_KEY_DATES: 'Clicked View key dates (pro)',
  CLICKED_VIEW_ALL_APPOINTMENTS: 'Clicked View All Appointments',
  CLICKED_FORUM: 'Clicked See Forum (pro)',
  DOWNLOADED_SEEKUBE_CALENDAR: 'Downloaded Seekube Calendar (pro)',
  EXPORTED_APPOINTMENT_CALENDAR: 'Exported Appointment Calendar (pro)',
  CHANGED_APPOINTMENT: 'Changed Appointment (pro)',
  CLICKED_CHANGE_APPOINTMENT: 'Clicked change appointement (pro)',
  CANCELED_APPOINTMENT: 'Canceled Appointment (pro)',
  SEARCHED_FOR_CANDIDATES: 'Searched for Candidates',
  DISPLAYED_CONTACT_INFO: 'Displayed Contact Info',
  ADDED_TO_TREATED_PROFILES: 'Added to "Profils Traités',
  MOVE_PROFILES: 'Move to (pro)',
  HID_CANDIDATES: 'Hid Candidates',
  REFUSED_CANDIDATES: 'Refused Candidates',
  DOWNLOADED_CV: 'Downloaded CV',
  EDITED_STARS: 'Edited Stars (pro)',
  DELETE_SLOTS: 'Deleted Availabilities (pro)',
  CREATED_SLOTS: 'Created availabilities (pro)',
  CLICKED_CREATED_SLOTS: 'Clicked create availabilities (pro)',
  QUIT_CREATING_SLOTS: 'Quit creating availabilities (pro)',
  CLICKED_QUIT_CREATING_SLOTS: 'Clicked quit creating availabilities (pro)',
  EDIT_ORGANIZATION_PROFILE: 'Edited Company Profile (pro)',
  CLICKED_FEEDBACK_LATER: 'Clicked later',
  CLICKED_FEEDBACK_NO_SHOW: 'Clicked no show',
  CLICKED_CREATED_OFFER: 'Clicked Created Offer (pro)',
  CLICKED_EXISTING_OFFER: 'Created Existing Offer (pro)',
  SEARCHED_OFFERS_BY_EVENTS: 'Searched Offers by Event (pro)',
  CLICKED_SAVE_STAND: 'Clicked save stand (pro)',
  CLICKED_PUBLISH_STAND: 'Clicked publish stand (pro)',
  CLICKED_VIEW_PROFILE: 'Clicked view profile (pro)',
  EDIT_SLOTS: 'Edited Availabilities (pro)',
  EDIT_PROFILE: 'Edited Profile (pro)',
  EDITED_SEND_INVITATION: 'Edited send invitation calendar (pro)',
  INVITED_USER: 'Invited User (pro)',
  PUBLISHED_OFFER: 'Published Offer (pro)',
  DRAFTED_OFFER: 'Drafted Offer (pro)',
  DELETED_OFFER: 'Deleted Offer (pro)',
  SEARCHED_FOR_CANDIDATES_BY_OFFERS: 'Searched for Candidates by Offer',
  SET_APPOINTMENT: 'Set Appointment (pro)',
  CLICKED_DRAFT: 'Clicked draft',
  SWITCH_ACCOUNT: 'Switched Account (pro)',
  CLICKED_CONTACT_SALES: 'Clicked Contact Sales (pro)',
  CLICKED_AGENDA_VIEW: 'Edited calendar view (pro)',
  CANCELED_RECRUITER_PARTICIPATION: 'Canceled Recruiter Participation',
  CANCELED_COMPANY_PARTICIPATION: 'Canceled Company Participation',
  SORT_NEW_CANDIDATES: 'Searched by new candidat',
  CREATED_NEW_TEMPLATE: 'Created new template',
  UPDATED_TEMPLATE: 'Updated template',
  DELETED_TEMPLATE: 'Deleted template',
  USED_TEMPLATE: 'Used template',
  DOWNLOADED_APPOINTMENT_PLANNING: 'Downloaded Appointment Planning',
  SENT_NEGATIVE_EMAIL: 'Sent negative email',
  CLICKED_CONNECT_NYLAS: 'Clicked connect Nylas',
  CLICKED_DISCONNECT_NYLAS: 'Clicked disconnect Nylas',
  TOGGLE_SYNC_SLOTS: 'Toggle sync slots',
  TOGGLE_SYNC_APPOINTMENTS: 'Toggle sync appointments',
  CLICKED_REDIRECT_TO_SYNC: 'Clicked redirect to sync',
  EDITED_SYNC_CALENDAR: 'Edited sync calendar',
  DOWNLOADED_SEVERAL_CVS: 'Downloaded Several CVs',
  CLICKED_LEARN_PLAN: 'Clicked Learn More Plan',
  CLICKED_INFO_PLAN: 'Clicked Request Info Plan',
  CLICK_SEND_REQUEST_PLAN: 'Clicked Send Request Plan',
  EXPORTED_LIVES_DATA: 'Exported lives data (owner)',
  CLICKED_ACCESS_SCHOOL_EVENTS: 'Clicked access school events',
  CLICKED_DISCOVER_SCHOOL_EVENTS: 'Clicked discover school events',
  CLICKED_DISCOVER_OUR_OFFERS: 'Clicked discover our offers',
};

const TEMPLATES = {
  APPLICATION_VALIDATED: 'application-validated',
  APPLICATION_REFUSED: 'application-refused',
  PROPOSITION: 'proposition',
  PROPOSITION_JPO: 'proposition-jpo',
  EDIT_DATE: 'edit-date',
  EDIT_OWNER: 'edit-owner',
  CANCEL_INTERVIEW: 'cancel-interview',
  NEGATIVE_SCORING: 'interview-negative-scoring',
  EDIT_APPLICATION_OWNER: 'edit-application-owner',
};

const JOTFORM_URL = {
  admin: 'https://admin.typeform.com/form',
  edit: '/create',
  submissions: '/results',
  form: 'https://seekube.typeform.com/to/',
};

const CONTINENT_LOCATION = {
  AD: 'Europe',
  AE: 'Asie',
  AF: 'Asie',
  AG: 'Amérique du Nord',
  AI: 'Amérique du Nord',
  AL: 'Europe',
  AM: 'Asie',
  AN: 'Amérique du Nord',
  AO: 'Afrique',
  AR: 'Amérique du Sud',
  AS: 'Océanie',
  AT: 'Europe',
  AU: 'Océanie',
  AW: 'Amérique du Nord',
  AZ: 'Asie',
  BA: 'Europe',
  BB: 'Amérique du Nord',
  BD: 'Asie',
  BE: 'Europe',
  BF: 'Afrique',
  BG: 'Europe',
  BH: 'Asie',
  BI: 'Afrique',
  BJ: 'Afrique',
  BM: 'Amérique du Nord',
  BN: 'Asie',
  BO: 'Amérique du Sud',
  BR: 'Amérique du Sud',
  BS: 'Amérique du Nord',
  BT: 'Asie',
  BW: 'Afrique',
  BY: 'Europe',
  BZ: 'Amérique du Nord',
  CA: 'Amérique du Nord',
  CC: 'Asie',
  CD: 'Afrique',
  CF: 'Afrique',
  CG: 'Afrique',
  CH: 'Europe',
  CI: 'Afrique',
  CK: 'Océanie',
  CL: 'Amérique du Sud',
  CM: 'Afrique',
  CN: 'Asie',
  CO: 'Amérique du Sud',
  CR: 'Amérique du Nord',
  CU: 'Amérique du Nord',
  CV: 'Afrique',
  CX: 'Asie',
  CY: 'Asie',
  CZ: 'Europe',
  DE: 'Europe',
  DJ: 'Afrique',
  DK: 'Europe',
  DM: 'Amérique du Nord',
  DO: 'Amérique du Nord',
  DZ: 'Afrique',
  EC: 'Amérique du Sud',
  EE: 'Europe',
  EG: 'Afrique',
  EH: 'Afrique',
  ER: 'Afrique',
  ES: 'Europe',
  ET: 'Afrique',
  FI: 'Europe',
  FJ: 'Océanie',
  FK: 'Amérique du Sud',
  FO: 'Europe',
  FR: 'Europe',
  GA: 'Afrique',
  GB: 'Europe',
  TC: 'Amérique du Nord',
  TG: 'Afrique',
  TK: 'Océanie',
  TM: 'Asie',
  TN: 'Afrique',
  TO: 'Océanie',
  TR: 'Asie',
  TT: 'Amérique du Nord',
  TV: 'Océanie',
  UA: 'Europe',
  UG: 'Afrique',
  US: 'Amérique du Nord',
  UY: 'Amérique du Sud',
  UZ: 'Asie',
  VE: 'Amérique du Sud',
  VI: 'Amérique du Nord',
  VN: 'Asie',
  VU: 'Océanie',
  WF: 'Océanie',
  YE: 'Asie',
  ZM: 'Afrique',
  ZW: 'Afrique',
  AX: 'Europe',
  BQ: 'Amérique du Nord',
  IO: 'Asie',
  VG: 'Amérique du Nord',
  KH: 'Asie',
  KY: 'Amérique du Nord',
  TD: 'Afrique',
  KM: 'Afrique',
  HR: 'Europe',
  CW: 'Amérique du Nord',
  SV: 'Amérique du Nord',
  GQ: 'Afrique',
  GF: 'Amérique du Sud',
  PF: 'Océanie',
  GM: 'Afrique',
  GE: 'Asie',
  GH: 'Afrique',
  GI: 'Europe',
  GR: 'Europe',
  GL: 'Amérique du Nord',
  GD: 'Amérique du Nord',
  GP: 'Amérique du Nord',
  GU: 'Océanie',
  GT: 'Amérique du Nord',
  GG: 'Europe',
  GN: 'Afrique',
  GW: 'Afrique',
  GY: 'Amérique du Sud',
  HT: 'Amérique du Nord',
  VA: 'Europe',
  HN: 'Amérique du Nord',
  HK: 'Asie',
  HU: 'Europe',
  IS: 'Europe',
  IN: 'Asie',
  ID: 'Asie',
  IR: 'Asie',
  IQ: 'Asie',
  IE: 'Europe',
  IM: 'Europe',
  IL: 'Asie',
  IT: 'Europe',
  JM: 'Amérique du Nord',
  JP: 'Asie',
  JE: 'Europe',
  JO: 'Asie',
  KZ: 'Asie',
  KE: 'Afrique',
  KI: 'Océanie',
  KP: 'Asie',
  KR: 'Asie',
  KW: 'Asie',
  KG: 'Asie',
  LA: 'Asie',
  LV: 'Europe',
  LB: 'Asie',
  LS: 'Afrique',
  LR: 'Afrique',
  LY: 'Afrique',
  LI: 'Europe',
  LT: 'Europe',
  LU: 'Europe',
  MO: 'Asie',
  MK: 'Europe',
  MG: 'Afrique',
  MW: 'Afrique',
  MY: 'Asie',
  MV: 'Asie',
  ML: 'Afrique',
  MT: 'Europe',
  MH: 'Océanie',
  MQ: 'Amérique du Nord',
  MR: 'Afrique',
  MU: 'Afrique',
  YT: 'Afrique',
  MX: 'Amérique du Nord',
  FM: 'Océanie',
  MD: 'Europe',
  MC: 'Europe',
  MN: 'Asie',
  ME: 'Europe',
  MS: 'Amérique du Nord',
  MA: 'Afrique',
  MZ: 'Afrique',
  MM: 'Asie',
  NA: 'Afrique',
  NR: 'Océanie',
  NP: 'Asie',
  NL: 'Europe',
  NC: 'Océanie',
  NZ: 'Océanie',
  NI: 'Amérique du Nord',
  NE: 'Afrique',
  NG: 'Afrique',
  NU: 'Océanie',
  NF: 'Océanie',
  MP: 'Océanie',
  NO: 'Europe',
  OM: 'Asie',
  PK: 'Asie',
  PW: 'Océanie',
  PS: 'Asie',
  PA: 'Amérique du Nord',
  PG: 'Océanie',
  PY: 'Amérique du Sud',
  PE: 'Amérique du Sud',
  PH: 'Asie',
  PN: 'Océanie',
  PL: 'Europe',
  PT: 'Europe',
  PR: 'Amérique du Nord',
  QA: 'Asie',
  RE: 'Afrique',
  RO: 'Europe',
  RU: 'Europe',
  RW: 'Afrique',
  BL: 'Amérique du Nord',
  SH: 'Afrique',
  KN: 'Amérique du Nord',
  LC: 'Amérique du Nord',
  MF: 'Amérique du Nord',
  PM: 'Amérique du Nord',
  VC: 'Amérique du Nord',
  WS: 'Océanie',
  SM: 'Europe',
  ST: 'Afrique',
  SA: 'Asie',
  SN: 'Afrique',
  RS: 'Europe',
  SC: 'Afrique',
  SL: 'Afrique',
  SG: 'Asie',
  SX: 'Amérique du Nord',
  SK: 'Europe',
  SI: 'Europe',
  SB: 'Océanie',
  SO: 'Afrique',
  ZA: 'Afrique',
  SS: 'Afrique',
  LK: 'Asie',
  SD: 'Afrique',
  SR: 'Amérique du Sud',
  SJ: 'Europe',
  SZ: 'Afrique',
  SE: 'Europe',
  SY: 'Asie',
  TW: 'Asie',
  TJ: 'Asie',
  TZ: 'Afrique',
  TH: 'Asie',
  TL: 'Asie',
  UM: 'Océanie',
};

const ALIAS_MAILCHIMP = [
  'contrat',
  'duration',
  'availability',
  'position',
  'technos',
  'mobility',
  'level',
  'metier',
  'experience',
  'license',
  'sector',
  'size',
];

const TOPICS = {
  coaching: 'coaching',
  xp: 'xp',
  company: 'company',
  job: 'job',
  recruitment: 'recruitment',
  culture: 'culture',
  other: 'other',
};

const CONFERENCE_TOPICS = [
  TOPICS.coaching,
  TOPICS.xp,
  TOPICS.company,
  TOPICS.job,
  TOPICS.recruitment,
  TOPICS.culture,
  TOPICS.other,
];

const CONFERENCE_TOPICS_INDEX = {
  [TOPICS.coaching]: 9,
  [TOPICS.xp]: 4,
  [TOPICS.company]: 0,
  [TOPICS.job]: 2,
  [TOPICS.recruitment]: 3,
  [TOPICS.culture]: 5,
  [TOPICS.other]: 7,
};

/**
 * Colors
 */

const COLORS = {
  secondary: '#385077',
  white: '#ffffff',
};

/**
 * Locales
 */

const LOCALES = {
  fr: 'fr',
  en: 'en',
};

/**
 * Debounce in ms
 */

const DEBOUNCE = 300;

/**
 * Warning do no change order, only add item
 */

const TAG_COLORS = [
  'orange',
  'teal',
  'orchid',
  'blue',
  'pink',
  'yellow',
  'gold',
  'royalBlue',
  'cherry',
  'apple',
];

const MEETING_SERVICES = {
  teams: {
    text: 'Teams',
    patternInUrl: 'https://teams.microsoft.com',
  },
  googleMeet: {
    text: 'Google meet',
    patternInUrl: 'meet.google.com',
  },
  zoom: {
    text: 'Zoom',
    patternInUrl: 'https://zoom.us',
  },
  Webex: {
    text: 'Webex',
    patternInUrl: 'webex.com',
  },
  Skype: {
    text: 'Skype',
    patternInUrl: 'meet.lync',
  },
};

const SLOT_TYPE = {
  INTERVIEW: 'interview',
  INFORMAL1TO1: 'informal1to1',
  CONFERENCE: 'conference',
};

const INTERACTION_TYPE = {
  proposition: 'proposition',
  application: 'application',
  visitStand: 'visit-stand',
  applicationAuto: 'application-auto',
  informal1to1: 'informal1to1',
  informal1to1Pending: 'informal1to1-pending',
};

const APPOINTMENT_ORIGIN = {
  informal1to1: 'informal1to1',
  sourcing: 'sourcing',
  auto: 'auto',
};

const APPOINTMENT_STATUS = {
  ACCEPTED: 'accepted',
  ALREADY_INTERACTION: 'alreadyInteraction',
  DISABLED: 'applicationsDisabled',
  NO_DATE: 'nodate',
  NO_SLOT: 'noSlot',
  PENDING: 'pending',
  REFUSED: 'refused',
  SKIP: 'skip',
  UNCONFIRMED: 'unconfirmed',
  WAITING_LIST: 'waiting-list',
};

const CANDIDATE_JD_VIEWS = {
  exponents: 'exponents',
  jobs: 'jobs',
  appointments: 'appointments',
  informal1to1: 'informal1to1',
  informal1to1s: 'informal1to1s',
};

const ACL = {
  EDIT_USER: 'editUser',
  ADD_USER: 'addUser',
  ADD_EXPONENT_USER: 'addExponentUser',
  REMOVE_USER_FROM_ORGANIZATION: 'removeUserFromOrganization',
  REMOVE_USER_FROM_EXPONENT: 'removeUserFromExponent',
  EDIT_MASTER_STAND: 'editMasterStand',
  EDIT_EVENT_STAND: 'editStand',
  EDIT_ROLE: 'editRole',
  INVITE_USER: 'inviteUser',
  ATS: 'ats',
};

const CONTRACTS_WITHOUT_DURATION = ['CDI'];
const CONTRACTS_COMPATIBLE_WITH_NO_DURATION = ['CDD / Temporaire'];
const CONTRACTS_OTHERS = [
  'Stage',
  "Stage de fin d'études",
  "Contrat d'apprentissage",
  'Contrat de professionalisation',
  'Alternance',
  'Stage Alterné',
];

const SUPPORTED_CALENDARS = {
  ical: 'Apple',
  google: 'Google',
  ms365: 'Outlook',
  yahoo: 'Yahoo',
};

const CRITERIA = {
  CONTRACT: 'CONTRACT',
  MOBILITY: 'MOBILITY',
  TARGETS: 'TARGETS',
  DURATION: 'DURATION',
  SECTORS: 'SECTORS',
  RQTH: 'RQTH',
  POSITION: 'POSITION',
};

const API_CUSTOM_ERRORS = {
  passwordAlreadyUsed: 'password_policy_already_used',
  passwordPolicyNotCompliant: 'password_policy_not_compliant',
  blockedAccount: 'blocked_account',
  wrongPassword: 'wrong_password',
  userNotActive: 'user_not_active',
  userNotFound: 'User not found',
  tokenAlreadyUsed: 'token_already_used',
  invalidCaptcha: 'invalid_captcha',
  conflict: 'Conflict',
  userInAnotherStand: 'user_in_another_stand',
  organizationLastAdmin: 'you cannot remove the last admin of the organization',
};

const PHONE_DEFAULT_INDICATORS = {
  fr: 'FR',
  en: 'GB',
};

const DATES_FORMAT = {
  fr: 'DD MMMM',
  en: 'MMMM DD',
};

const FULL_DATE_FORMATS = {
  fr: 'DD-MM-YYYY',
  en: 'YYYY-MM-DD',
};

const GTM_EVENTS = {
  generic: 'generic',
  virtualPageDisplay: 'virtual.page.display',
};

const GTM_EVENTS_NAME = {
  generic: 'generic',
  redirect: 'redirect',
};

const GTM_EVENTS_INFOS = {
  readMoreLanding: 'read_more_landing',
  viewOfferLanding: 'view_offer_landing',
  inscription: 'inscription',
  preinscription: 'preinscription',
};

const GTM_EVENT_PAGE_SUBJECT = {
  home: 'home',
  result: 'result',
};

const GTM_EVENT_PAGE_CATEGORY = {
  landing: 'landing',
  searchEvent: 'search_event',
};

const FREQUENCY_MAILS_NOTIFICATION = {
  weekly: 'weekly',
  bimonthly: 'bimonthly',
  monthly: 'monthly',
  never: 'never',
};

const IMAGES_AUTHORIZED_TYPES = {
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
};

const OFFER_DATE_AVAILABILITY = {
  AVAILABLE_NOW: 1,
};

const REGEXPS = {
  EMAIL:
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
};

/**
 * Default exports
 */
export {
  OFFER_DATE_AVAILABILITY,
  KEY_CODE,
  PARTICIPANT_ROLE,
  USER_ROLE,
  EVENT_STATUS,
  EVENT_FORMAT,
  ANALYTICS_RECRUITER,
  CONTEXT_URLS,
  TEMPLATES,
  JOTFORM_URL,
  CONTINENT_LOCATION,
  ALIAS_MAILCHIMP,
  DISABLE_SERVICE_FOR_COMPANIES,
  INTERVIEW_CONTEXTS,
  ENABLE_SERVICE_FOR_TEST,
  LINKS,
  COLORS,
  LOCALES,
  DEBOUNCE,
  CONFERENCE_TOPICS,
  CONFERENCE_TOPICS_INDEX,
  TAG_COLORS,
  MEETING_SERVICES,
  USERS_TYPE,
  SLOT_TYPE,
  APPOINTMENT_ORIGIN,
  APPOINTMENT_STATUS,
  INTERACTION_TYPE,
  CANDIDATE_JD_VIEWS,
  DASHBOARD_MODE,
  EVENT_TYPE,
  ACL,
  CONTRACTS_WITHOUT_DURATION,
  CONTRACTS_COMPATIBLE_WITH_NO_DURATION,
  CONTRACTS_OTHERS,
  SUPPORTED_CALENDARS,
  USERS_EVENT_ROLES,
  WORDS_IN_SLUG_FOR_WOMEN_EVENT,
  API_CUSTOM_ERRORS,
  CRITERIA,
  PHONE_DEFAULT_INDICATORS,
  DATES_FORMAT,
  GTM_EVENTS,
  GTM_EVENTS_NAME,
  GTM_EVENTS_INFOS,
  GTM_EVENT_PAGE_SUBJECT,
  GTM_EVENT_PAGE_CATEGORY,
  FREQUENCY_MAILS_NOTIFICATION,
  IMAGES_AUTHORIZED_TYPES,
  FULL_DATE_FORMATS,
  REGEXPS,
};
